import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type VenueAnchorPropsType = {
  venue: LinkableEntityType;
  children?: React.ReactNode;
};

export const VenueAnchor: React.FC<VenueAnchorPropsType> = ({
  venue: { id, name },
  children,
}) => {
  return (
    <Anchor key={id} to={`/venues/$id`} params={{ id }}>
      {children ?? name}
    </Anchor>
  );
};
